import { create } from 'zustand';

interface LayoutState {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
}

export const useLayoutStore = create<LayoutState>((set) => ({
  collapsed: true,
  setCollapsed: (collapsed: boolean) => set({ collapsed }),
})); 